import { render, staticRenderFns } from "./ActionPostbackScoring.vue?vue&type=template&id=80806bd2&"
import script from "./ActionPostbackScoring.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports